import { StaffManagerFormValues } from "../components/forms/StaffManagerForm/StaffManagerForm.types";
import { StaffManagerListItem } from "../staff.types";

export const getInitialManagerFormValues = (
  editableManager: StaffManagerListItem | null
): StaffManagerFormValues => ({
  id: editableManager?.id,
  firstName: editableManager?.firstName ?? "",
  lastName: editableManager?.lastName ?? "",
  email: editableManager?.email ?? "",
  image: editableManager?.image ?? null,
  password: "",
  repeatPassword: "",
  privileges: editableManager?.privileges ?? [],
  permissions: editableManager?.permissions ?? []
});
